import styled from 'styled-components';
import { Paragraph } from '@zillow/constellation';

const StyledParagraph = styled(Paragraph)`
  /* Needed for IE11. */
  width: 100%;
`;

export default StyledParagraph;
